// src/InvoiceForm.js
import React, { useState, useEffect }  from 'react';
import '../../Css/AjouterFacture.css'; // Import the CSS file




import { addClient } from '../../API/ajouterClient'; // Import the fetchRooms function
import { checkPassportExistence } from '../../API/checkPassportExisting'; // Import the fetchRooms function
/*import { fetchFactureClients } from '../../API/fetchFactureClients'; // Import the fetchRooms function*/
import { fetchFactureOrganismes } from '../../API/fetchFactureOrganismes'; // Import the fetchRooms function
import { fetchHotels } from '../../API/fetchHotels'; // Import the fetchRooms function
import { fetchRoomsHotelFacture } from '../../API/fetchRoomsHotelFacture'; // Import the fetchRooms function
import { editFacture } from '../../API/editFacture';
import { fetchOrgaismeRate } from '../../API/getTauxOrganisme';





import { calculateCommission } from '../../Functions/CalculateCommission'; // Import the TVA calculatio
import { calculateComtax  } from '../../Functions/CalculateCommissionTax'; // Import the TVA calculatio
import { updatePaymentRowsQuantities } from '../../Functions/calculateConsomQuantities'; // Import 
import { calculateEcart } from '../../Functions/CalculateEcart'; // Import the TVA calculatio
import { calculateSolde } from '../../Functions/CalculateSolde'; // Import the TVA calculatio
import { calculateTotalConsom } from '../../Functions/calculateTotalConsom'; // Import the TVA calculatio
import { CalculateTotalFacture } from '../../Functions/CalculateTotalFacture'; // Import the TVA calculatio
import { calculateTvaFacture } from '../../Functions/calculateTvaFacture'; // Import the TVA calculatio
/*import { existingbill } from '../../Functions/checkForOverlaps'; // Import the TVA calculatio*/
import { updatePaymentRowsWithCheckInOut } from '../../Functions/updatePaymentRowsWithCheckInOut'; // Import the TVA calculatio
/*import { getFormattedDate } from '../../Functions/currentDateFacture'; // Import the TVA calculatio
import { fetchClientnameFrompassport } from '../../Functions/fetchClientnameFrompassport';*/
import { calculateRoomPrice } from '../../Functions/fetchAndParseRoomPrice';
import { CalculateLogementquantite } from '../../Functions/CalculateLogementquantite';
import { updateStayRowTotalLoge } from '../../Functions/calculateTotalLoge';
import { factClientCheck } from '../../Functions/factClientCheck';
import { checkForOverlap } from '../../Functions/checkForOverlaps';
import { checkFactureExisting } from '../../Functions/checkFactureExisting';
/*import { convertDate2 } from '../../Functions/formatDate';*/














const EditFactureModal = ({ isOpen, factures, onClose, onSave }) => {

    const [identifiant, setIdentifiant] = useState('');
    const [currentDate, setCurrentDate] = useState('');
    const [rows, setRows] = useState([{ passport: '', clientName: '',clientCheckIn:'',clientCheckOut:'', applytax:'oui', nationnalite: 'MGR' }]);
    const [stayRows, setStayRows] = useState([{ pax: '', typeChambre: '',prixtype: '', pension: '', checkIn: '', checkOut: '', quantite: 0, prixChambre: 0, totalLoge: 0}]);
    const [paymentRows, setPaymentRows] = useState([{ description: '', enterDate:'',sortDate:'', unitPrice: '',quantiteConsom: '',totalConsom: 0 }]);
    const [totalFacture, setTotalFacture] = useState(0);
    const [timbre, setTimbre] = useState(1);
    const [solde, setSolde] = useState(0);
    const [tva, setTva] = useState(0);
    const [ecart, setEcart] = useState(0);
    const [commission, setCommission] = useState(0);
    const [comtax, setComtax] = useState(0);
    const [montantAchat, setMontantAchat] = useState('');
    const [hotelList, setHotelList] = useState([]); 
    const [roomList, setRoomList] = useState([]); // Room list based on selected hotel
    const [organisme, setOrganisme] = useState([]);
    const [selectedHotel, setSelectedHotel] = useState(''); // Selected hotel name
    const [selectedorganisme, setSelectedorganisme] = useState('');
    const [nbrfact, setNbrfact] = useState(''); 
    const [paymentRowsIndex, setPaymentRowsIndex] = useState(0); // State to store client data
    const [errorMessage, setErrorMessage] = useState('');
    const [notification, setNotification] = useState([]);
    const [overlapMessage, setOverlapMessage] = useState('');
    const [observation, setObservation] = useState('');
    const [files, setFiles] = useState([]);
    const [commissionRate, setCommissionRate] = useState('');
    const [paymentError, setPaymentError] = useState('');
    const [idfact, setIdfact] = useState('');
    const [errorPassport, setErrorPassport] = useState('');
    const [prixTypes, setPrixTypes] = useState([]);
    const [autoTax, setAutoTax] = useState('');

    const username = localStorage.getItem('username'); 
    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;
    


// Fetch data on component mount
useEffect(() => {

        let { clients, consommations, logements } = factures[0];
        
        // Set the data in the state
        setIdfact(factures[0].id);
        setNbrfact(factures[0].nbrfact);
        setCurrentDate(factures[0].currentDate);
        setIdentifiant(factures[0].id_facture);

        setRows(clients);
        setStayRows(logements);
        setPaymentRows(consommations);
        let mntachat = parseFloat(factures[0].montantAchat).toFixed(3).replace(".",",");
        setMontantAchat(mntachat);
        setSelectedHotel(factures[0].selectedHotel);
        setSelectedorganisme(factures[0].selectedorganisme);

        fetchOrganismeRate(factures[0].selectedorganisme);
        setObservation(factures[0].observation);
        setAutoTax(factures[0].autoTax);
        setTva(factures[0].tva);

        console.log("factures[00000000]",factures[0]);
}, [factures]);



    // retrieve the list of all hotel name when the component mounts
    useEffect(() => {
        const fetchHotelData = async () => {
            let data = await fetchHotels(); // Call the imported function
            setHotelList(data); // Set the hotel names
        };

        fetchHotelData();
    }, []); // This effect runs only once when the component mounts


        const fetchPrixTypes = async () => {
            const response = await fetch(`${apiUrl}/api/type/prix`, {
              headers: { 'Authorization': `Bearer ${token}` },
            });
            const data = await response.json();
            setPrixTypes(data || []); // Ensure data is always an array
        };



            // Update the enterDate and sortDate for paymentRows
            useEffect(() => {
        
                const fetchFactureData = async () => {
                    if (nbrfact && selectedHotel && currentDate) {
                        // Call the checkFactureExisting function and await its result
                        const msg = await checkFactureExisting(nbrfact, selectedHotel,identifiant);
                        setErrorMessage(msg); // Update state with the returned message
                    }else{
                        setErrorMessage(""); // Update state with the returned message
                    }
                };
        
                fetchFactureData();
            }, [nbrfact,selectedHotel]);
    
    
        useEffect(() => {
            fetchPrixTypes();
        }, []);





    //retrieve the list of all organisme name when the component mounts
    useEffect(() => {
        const fetchOrganismeData = async () => {
            let data = await fetchFactureOrganismes(); // Call the imported function
            setOrganisme(data); // Set the organisme names
        };
    
        fetchOrganismeData();
    }, []); // This effect runs only once when the component mounts


    

    // Fetch the list of the room when the select the hotel or when the selected hotel changes
    useEffect(() => {
        const fetchRoomData = async () => {
            let data = await fetchRoomsHotelFacture(selectedHotel); // Call the imported function
            setRoomList(data); // Set the room list for the selected hotel
        };
    
        fetchRoomData(); // Fetch rooms whenever the selected hotel changes
    }, [selectedHotel]); // This effect depends on selectedHotel




    // Calculate total TVA
    useEffect(() => {
        const calculateTva = async () => {
            if (
                rows.every((row) => 
                    row.clientCheckIn &&
                    row.clientCheckOut &&
                    row.applytax &&
                    String(row.clientCheckIn).trim() !== "" &&
                    String(row.clientCheckOut).trim() !== "" &&
                    row.applytax !== "" &&
                    row.nationnalite !== ""
                ) && selectedHotel !== "" &&
                autoTax === "Oui"
            ) {
                const tva = await calculateTvaFacture(rows, selectedHotel);
                let tvaa = parseFloat(tva).toFixed(3).replace(".",",");
                setTva(tvaa);
            }
        }

        calculateTva();
    }, [rows, selectedHotel,autoTax]);




    // Calculate the Ecart
    useEffect(() => {
        if(totalFacture && montantAchat && timbre && tva){
            const ecart = calculateEcart(totalFacture, timbre, tva, montantAchat);
            const formattedEcart =  Math.abs(ecart).toLocaleString('fr-FR', { minimumFractionDigits: 3 })+(ecart < 0 ? '-' : '');
            setEcart(formattedEcart);
        }
    }, [totalFacture,timbre, tva, montantAchat]);



    // Calculate the Total facture
    useEffect(() => {
        if (
           paymentRows &&
           stayRows &&
           stayRows.every((row) => row.totalLoge > 0) && // Check TotalLoge > 0 in stayRows
           paymentRows.every((row) => row.totalConsom > 0) // Check TotalConsom > 0 in paymentRows
        ) {
           // Call the function to calculate totalFacture
          CalculateTotalFacture(stayRows, paymentRows, setTotalFacture );
        }
    }, [tva,paymentRows, stayRows]); // Recalculate when paymentRows or stayRows change




    // Handle change organisme selection field
    const handleOrganismeChange = async (event) => {
        let organisme = event.target.value;
        setSelectedorganisme(organisme); 
        let rate = await fetchOrgaismeRate(organisme);
        setCommissionRate(rate);
     };



    const fetchOrganismeRate = async (organismee) => {
        let rate = await fetchOrgaismeRate(organismee);
        setCommissionRate(rate);
    }


    //Calculate the solde
    useEffect(() => {
        // Call the function to calculate the solde and update payment
        let solde = calculateSolde(totalFacture, timbre,tva, commission, comtax);
        setSolde(solde);
    }, [totalFacture, timbre,tva, commission, comtax]); // Recalculate when these values change

    




    //Calculate the commission
    useEffect(() => {
        if(totalFacture > 0){
            // Calculate commission based on totalFacture using the utility function
            let tot = calculateCommission(totalFacture, commissionRate);
            setCommission(tot);
        }
    }, [totalFacture, commissionRate]); // Recalculate when paymentRows, stayRows, or payment change




    // Calculate Tax sur commission
    useEffect(() => {
        // Calculate commtax based on commission using the utility function
        let tax = calculateComtax(commission);
        setComtax(tax);
    }, [commission]); // Recalculate when commission changes



        // Update the enterDate and sortDate for paymentRows
        useEffect(() => {
            if(paymentRowsIndex > 0){
                // Use the utility function to update paymentRows based on stayRows
                updatePaymentRowsWithCheckInOut(stayRows, paymentRows, setPaymentRows); 
            }
        }, [paymentRowsIndex]);



    /*//Fix paymentRows field to 3 digit after comma
    const handlePaymentRowBlur = (index, field) => {
        const updatedPaymentRows = [...paymentRows];
        const value = parseFloat(updatedPaymentRows[index][field]);
      
        if (!isNaN(value)) {
          updatedPaymentRows[index][field] = value.toFixed(3);
          setPaymentRows(updatedPaymentRows);
        }
    };*/




    
    // fix the Montant_achat value to 3 digit after comma
    const handleBlur = () => {
        setMontantAchat(parseFloat(montantAchat).toFixed(3));
    };





    const handleFileChange = async (e) => {
        const files = e.target.files;
      
        if (files.length > 0) {
          const formData = new FormData();
          const newFiles = [];
          const maxFileSize = 5 * 1024 * 1024; 
      
          for (let file of files) {
            if (file.type === "application/pdf") {
              if (file.size > maxFileSize) {
                alert("File is too large. Please upload a file smaller than 5 MB.");
                e.target.value = ""; 
                return; 
              }
              formData.append("files", file);
              newFiles.push(file);
            } else {
              alert("Please upload only JPEG files.");
              e.target.value = ""; 
              return; 
            }
          }
          setFiles((prevFiles) => [...prevFiles, ...newFiles]);
          e.target.value = ""; 
        }
      };


    // fix the Montant_achat value to 3 digit after comma
    const handleBlurUnitPrice = () => {
        const updatedPaymentRows = [...paymentRows];
        updatedPaymentRows.forEach((row, index) => {
            const value = parseFloat(row.unitPrice);
            if (!isNaN(value)) {
                updatedPaymentRows[index].unitPrice = value.toFixed(3);
                setPaymentRows(updatedPaymentRows);
            }
        });
    };



    // Handle change hotel selection field
    const handleHotelChange = (event) => {
       const hotel = event.target.value;
       setSelectedHotel(hotel); 
    };


    // Handle change commission_tax field
    const handletaxChange = (e) => {
       const tax = e.target.value;
       setAutoTax(tax); 
    };

    // Handle change commission_tax field
    const handletvaInputChange = (e) => {
       const tva= e.target.value;
       setTva(tva); 
    };



const handleTvaBlurr = () => {
if ( tva !== ""){
    let tvaString = parseFloat(tva).toFixed(3).toString();
    let tvaa = tvaString.replace('.', ',');
    setTva(tvaa);
} else {
    setTva("");
}
};



    // Handle change facture_number field
    const handleNbrfactChange = (event) => {
       const nbrFact = event.target.value;
       setNbrfact(nbrFact); 
    }; 



    // Handle change facture_number field
    const handleObservation = (event) => {
       const observation = event.target.value;
       setObservation(observation); 
    }; 

 

    
    // Handle chnage ecart field
    const handleEcartInputChange = (e) => {
       const ecart = e.target.value;
       setEcart(ecart); 
    };



    // Handle change Commission field
    const handleCommissionInputChange = (e) => {
       const commission = e.target.value;
       setCommission(commission); 
    };



    // Handle change commission_tax field
    const handleComtaxInputChange = (e) => {
       const comtax = e.target.value;
       setComtax(comtax); 
    };


    // Handle change Montant_achat field
    const handleMontantAchatInputChange = (e) => {
       let value = e.target.value;
        setMontantAchat(value);
    };


    // Fix numbers to 3 digit after comma
    const formatedNumber = (num) => {
        // Check if the input is a valid number
        if (num !== undefined && num !== null && !isNaN(num) && num > 0) {
            return parseFloat(num).toFixed(3);
        }
        return ""; // Return an empty string for invalid inputs
    };


//start Rows 
    //ADD  Rows for the passport and clientName
    const addRow = () => {
       setRows([...rows, { passport: '', clientName: '',clientCheckIn:'',clientCheckOut:'', applytax:'oui', nationnalite: 'MGR' }]);
    };

    //Delete  Rows for the passport and clientName
    const deleteRow = (index) => {
       const updatedRows = rows.filter((_, i) => i !== index);
           // Reset error message
           factClientCheck(updatedRows,setNotification, setErrorPassport);
           checkForOverlap(updatedRows, setOverlapMessage,identifiant);

        setRows([...updatedRows]);
    };

//Retrieve client name when input the passport and check for overlaps
const handleInputChange = async(index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;


    const passporto = updatedRows[index].passport;

    if (field === 'passport' ) {
            factClientCheck(updatedRows,setNotification, setErrorPassport);
    }

    setRows([...updatedRows]);


    const date1 = updatedRows[index].clientCheckIn;
    const date2 = updatedRows[index].clientCheckOut;


    if (date1 && date2) {
        checkForOverlap(updatedRows, setOverlapMessage, identifiant);
    }
};

//End Rows




//Start StayRows
    //ADD Rows for the Stayrows
    const addStayRow = () => {
        setStayRows([...stayRows, { pax: '', typeChambre: '',prixtype: '', pension: '', checkIn: '', checkOut: '', quantite: 0, prixChambre: 0, totalLoge: 0}]);
     }

    //Delete Rows for the Stayrows
    const deleteStayRow = (index) => {
       const updatedStayRows = stayRows.filter((_, i) => i !== index);
       setStayRows(updatedStayRows);

       updatePaymentRowsQuantities(updatedStayRows,paymentRows,setPaymentRows);
       updatePaymentRowsWithCheckInOut(updatedStayRows,paymentRows,setPaymentRows);
    };

    //change values Rows for Stayrows
    const handleStayInputChange = async (index, field, value) => {
        const updatedStayRows = [...stayRows];
        updatedStayRows[index][field] = value;



        let roomType=updatedStayRows[index].typeChambre; // Set the room type for the specific row
        let pension=updatedStayRows[index].pension;
        let checkIn=updatedStayRows[index].checkIn;
        let checkOut=updatedStayRows[index].checkOut;
        let prixtype=updatedStayRows[index].prixtype;


        if (field === 'typeChambre' || field === 'pension' || field === 'prixtype') {
            if (roomType && pension && prixtype) {
              updatedStayRows[index].prixChambre = await calculateRoomPrice(pension,selectedHotel, roomType, prixtype);
            }else{
              updatedStayRows[index].prixChambre = 0;
            }
        }


        // Check for date changes to update quantite
        if (checkIn && checkOut) {
            updatedStayRows[index].quantite = await CalculateLogementquantite(checkIn,checkOut);
        }else{
            updatedStayRows[index].quantite = 0;
        }



        if (field === 'checkOut' || field === 'checkIn' || field === 'pension' || field === 'typeChambre') {
            const Totalloge = updateStayRowTotalLoge(stayRows, index);
            updatedStayRows[index].totalLoge = Totalloge;
        }



        if (field === 'checkOut' || field === 'checkIn') {
            updatePaymentRowsWithCheckInOut(stayRows,paymentRows,setPaymentRows);
        }


        // Check for date changes to update quantite
        if (field === 'typeChambre' || field === 'checkOut' || field === 'checkIn' || field === 'pax') {
            updatePaymentRowsQuantities(stayRows,paymentRows,setPaymentRows);
            calculateTotalConsom(paymentRows, setPaymentRows);
        }
        
        // Update state with a new reference to ensure re-render
        setStayRows([...updatedStayRows]);   
    };

//End StayRows



//Start paymentRows

//ADD Rows for the Payment rows
const addPaymentRow = () => {
    setPaymentRows([...paymentRows, { description: '', enterDate:'',sortDate:'', unitPrice: '',quantiteConsom: '',totalConsom: 0}]);
    setPaymentRowsIndex(paymentRowsIndex+1);
};

//Delete Rows for the Payment rows
const deletePaymentRow = (index) => {
    const updatedPaymentRows = paymentRows.filter((_, i) => i !== index);
    setPaymentRows(updatedPaymentRows);
};

//change values Rows for Payment rows
const handlePaymentInputChange = (index, field, value) => {
    const updatedPaymentRows = [...paymentRows];
    updatedPaymentRows[index][field] = value;


    if(field === 'description'){
        updatePaymentRowsQuantities(stayRows,paymentRows, setPaymentRows);
    }


    if(field === 'description' || field === 'unitPrice'){
        calculateTotalConsom(updatedPaymentRows, setPaymentRows);
    }

    // Update the payment rows state
    setPaymentRows([...updatedPaymentRows]);
};

//End paymentRows



const handleRemoveFilee = (index) => {
    setFiles((prevDocUrls) => prevDocUrls.filter((_, i) => i !== index)); // Remove file by index
  };




//Handle submit
const handleSubmit = async (e) => {
    e.preventDefault();

    const factClientData = rows.map(({ passport, clientName }) => ({
        passport,
        clientName,
    }));


    let doclink = { fileUrls: [], originalFileNames: [] };


    if (files.length !== 0){
        doclink= await uploadDocuments();
    }

    const data = {
        id: idfact,
        id_facture: identifiant,
        selectedHotel,   
        nbrfact, 
        currentDate,
        selectedorganisme,
        rows,               
        stayRows,           
        paymentRows, 
        totalFacture,
        commission,
        comtax,
        tva,
        solde,
        montantAchat: parseFloat(montantAchat).toFixed(3).replace(",","."),
        ecart,
        timbre, 
        observation,
        username,
        docUrls: doclink.fileUrls,
        filenames: doclink.originalFileNames,
        commissionRate,
        autoTax
    }

    try {
        // Step 1: Submit the invoice data
        await editFacture(identifiant,data);

        // Step 3: Handle each client based on their passport
        for (const client of factClientData) {
            const clientExists = await checkPassportExistence(client.passport);


            if (clientExists) {
                console.log(`Client with passport ${client.passport} already exists. Skipping...`);
            } else {
                // Add the client if they don't exist
                await addClient(client);
                console.log(`Client with passport ${client.passport} added successfully.`);
            }
        }

        alert(`Facture updated successfully num facture ${identifiant}.`);
        onClose(); // Close the modal after saving
       /* onSubmit();*/
    } catch (error) {
        console.error('Failed to submit invoice:', error);
        alert('An error occurred while submitting the facture');
    }
};



const uploadDocuments = async () => {
    try {

      const formData = new FormData();
  
      for (let file of files) {
        formData.append("files", file); 
      }

      const response = await fetch(`${apiUrl}/api/upload/facture-file`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`, 
        },
        body: formData,
      });
  
      const data = await response.json();

      if (response.ok) {
        return {
            fileUrls: data.fileUrls,
            originalFileNames: data.originalFileNames
          };
      } else {
        alert("File upload failed");
      }
      
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Error uploading file");
    }
  };




return (
<div className="Ajouterfacture__modal-overlay">
  <div className="Ajouterfacture__modal-content">
    <form className="Ajouterfacture__container">
        <h1 className="Ajouterfacture__title">فاتورة</h1>
        {errorMessage && <p style={{ color: 'red', padding: '5px 0', margin: '0'}}>{errorMessage}</p>}

        {/* First Section */}
        <div className="Ajouterfacture__form-section1">
            <table className="Ajouterfacture__form-table">
                <tbody>
                    <tr>
                        <td>
                            <select className="Ajouterfacture__select" name="hotels" value={selectedHotel} onChange={handleHotelChange} required>
                                <option value="">اختر النزل</option>
                                {hotelList.map((hotel, index) => (
                                    <option key={index} value={hotel.nameHotel}>{hotel.nameHotel}</option>
                                ))}
                            </select>
                        </td>
                        
                        <td className="td-x-large-width"><input className="Ajouterfacture__input" type="numbre" name="hotels" value={nbrfact} placeholder="رقم فاتورة النزل" onChange={handleNbrfactChange} required/></td>
                    </tr>
                    <tr>
                        <td>التاريخ</td>
                        <td className="td-x-large-width"><input className="Ajouterfacture__input" type="text" name="currentdate" value={currentDate} readOnly /></td>
                    </tr>
                </tbody>
            </table>
        </div>

        {/* Second Section */}
        <div className="Ajouterfacture__section-title">
            <select className="Ajouterfacture__select Ajouterfacture__padding-title" name="organisme" value={selectedorganisme} onChange={handleOrganismeChange} required>
                <option value="">اختر الموؤسسة</option>
                {organisme.map((org, index) => (
                    <option key={index} value={org.title}>{org.title}</option>
                ))}
            </select>
        </div>



{notification && notification.length > 0 && (
    <p style={{ color: 'green', whiteSpace: 'pre-line' }}>
      {notification}
    </p>
)}

{errorPassport && (
    <p style={{ color: 'red', whiteSpace: 'pre-line' }}>
      {errorPassport}
    </p>
)}

{overlapMessage && (
    <p style={{ color: 'red', whiteSpace: 'pre-line' }}>
      {overlapMessage}
    </p>
)}
       

       <div className="Ajouterfacture__form-section2">
            <table className="Ajouterfacture__form-table">
                <tbody className="border-bold">
                    <tr className="Ajouterfacture__table-header Ajouterfacture__tr-color Ajouterfacture__bold-text">
                        <td>رقم جواز سفر</td>
                        <td>اسم الحريف</td>
                        <td>تاريخ الدخول</td>
                        <td>تاريخ المغادرة</td>
                        <td>ظريبة الاقامة</td>
                        <td>الجنسية</td>
                    </tr>
                    {rows.map((row, index) => (
                        <tr className="Ajouterfacture__multivalue" key={index}>
                            <td className="td-large-width">
                                <input
                                    className="Ajouterfacture__input"
                                    type="text"
                                    placeholder="رقم جواز سفر"
                                    value={row.passport}
                                    onChange={(e) => handleInputChange(index, 'passport', e.target.value.toUpperCase())}
                                    required
                                />
                            </td>
                            <td>
                                <input
                                    className="Ajouterfacture__input"
                                    type="text"
                                    placeholder="اسم الحريف"
                                    value={row.clientName}
                                    onChange={(e) => handleInputChange(index, 'clientName', e.target.value)}
                                    required
                                />
                            </td>
                            <td className="td-small-width">
                                <input
                                    className="Ajouterfacture__input"
                                    type="date"
                                    placeholder="تاريخ الدخول"
                                    name="clientCheckIn"
                                    value={row.clientCheckIn}
                                    onChange={(e) => handleInputChange(index, 'clientCheckIn', e.target.value)}
                                    required
                                />
                            </td>
                            <td className="td-small-width">
                                <input
                                    className="Ajouterfacture__input"
                                    type="date"
                                    placeholder="تاريخ المغادرة"
                                    name="clientCheckOut"
                                    value={row.clientCheckOut}
                                    onChange={(e) => handleInputChange(index, 'clientCheckOut', e.target.value)}
                                    required
                                />
                            </td>
                            <td className="td-small-width Ajouterfacture__text-center">
                                <input
                                    type="checkbox"
                                    name={`applytax-${index}`}
                                    checked={row.applytax !== 'non'}
                                    onChange={(e) => handleInputChange(index, 'applytax', e.target.checked ? 'oui' : 'non')}
                                />
                            </td>

                            <td className="td-small-width Ajouterfacture__text-center">
                                <input
                                    type="radio"
                                    name={`nationnalite-${index}`}
                                    value= "MGR"
                                    checked={row.nationnalite === "MGR"}
                                    onChange={(e) => handleInputChange(index, 'nationnalite', e.target.value)}
                                />
                                ETR
                                <input
                                    type="radio"
                                    name={`nationnalite-${index}`}
                                    value= "ETR"
                                    checked={row.nationnalite === "ETR"}
                                    onChange={(e) => handleInputChange(index, 'nationnalite', e.target.value )}
                                />
                                MGR
                            </td>

                            {rows.length > 1 && (
                                <td className="Ajouterfacture__button td-smallest-width">
                                    <button
                                        type="button"
                                        onClick={() => deleteRow(index)}
                                        className="Ajouterfacture__delete-button"
                                    >
                                        حذف
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            <button type="button" onClick={addRow} className="Ajouterfacture__add-button">
                إضافة سطر
            </button>
        </div>
        

        {/* Third Section */}
        <h2 className="Ajouterfacture__section-title">الإقامة</h2>
        <div className="Ajouterfacture__form-section3">
            <table className="Ajouterfacture__form-table">
                <tbody>
                    <tr className="Ajouterfacture__table-header Ajouterfacture__tr-color Ajouterfacture__bold-text">
                        <td>عدد الاشخاص</td>
                        <td>الوصف</td>
                        <td>الصنف</td>
                        <td>نوع الإقامة</td>
                        <td>تاريخ الدخول</td>
                        <td>تاريخ المغادرة</td>
                        <td>السعر الفردي</td>
                        <td>الكمية</td>
                        <td>المجموع</td>
                    </tr>
                    {stayRows.map((row, index) => (
                        <React.Fragment key={index}>
                            <tr className="Ajouterfacture__multivalue">
                            <td className="Ajouterfacture__td-larger">
                                   <select
                                      className="Ajouterfacture__select Ajouterfacture__text-center"
                                      name="pax"
                                      value={row.pax}
                                      onChange={(e) => handleStayInputChange(index, 'pax', e.target.value)}
                                      required
                                    >
                                       <option value="" disabled>اختر</option>
                                       <option value="1">1</option>
                                       <option value="2">2</option>
                                       <option value="3">3</option>
                                       <option value="4">4</option>
                                       <option value="5">5</option>
                                       <option value="6">6</option>
                                       <option value="7">7</option>
                                       <option value="8">8</option>
                                       <option value="9">9</option>
                                       <option value="10">10</option>
                                    </select>
                                </td>

                                <td className="Ajouterfacture__td-larger">
                                    <select className="Ajouterfacture__select" name="typeChambre" value={row.typeChambre} onChange={(e) => handleStayInputChange(index, 'typeChambre', e.target.value)} required>
                                        <option value="" disabled>اختر نوع الغرفة</option>
                                        {roomList.map((room, index) => (
                                            <option key={index} value={room.room}>{room.room}</option>
                                        ))}
                                    </select>
                                </td>

                                <td className="Ajouterfacture__td-larger">
                                    <select
                                      className="Ajouterfacture__select"
                                      name="prixType"
                                      value={row.prixtype}
                                      onChange={(e) => handleStayInputChange(index, 'prixtype', e.target.value)}
                                      required
                                    >
                                    <option value="">اختر نوع السعر</option>
                                      {prixTypes.map((type) => (
                                        <option key={type.id} value={type.title}>
                                          {type.title}
                                        </option>
                                       ))}
                                    </select>
                                </td>
                                <td className="Ajouterfacture__td-larger">
                                   <select
                                      className="Ajouterfacture__select"
                                      name="pension"
                                      value={row.pension}
                                      onChange={(e) => handleStayInputChange(index, 'pension', e.target.value)}
                                      required
                                    >
                                       <option value="" disabled>اختر نوع الاقامة</option>
                                       <option value="اقامة فقط">اقامة فقط</option>
                                       <option value="اقامة مع فطور صباح">اقامة مع فطور صباح</option>
                                       <option value="نصف اقامة">نصف اقامة</option>
                                       <option value="اقامة كاملة">اقامة كاملة</option>
                                    </select>
                                </td>

                                <td className="Ajouterfacture__td-larger">
                                    <input
                                        className="Ajouterfacture__input"
                                        type="date"
                                        placeholder="تاريخ الدخول"
                                        name="checkIn"
                                        value={row.checkIn}
                                        onChange={(e) => handleStayInputChange(index, 'checkIn', e.target.value)}
                                        required
                                    />
                                </td>
                                <td className="Ajouterfacture__td-larger">
                                    <input
                                        className="Ajouterfacture__input"
                                        type="date"
                                        placeholder="تاريخ المغادرة"
                                        name="checkOut"
                                        value={row.checkOut}
                                        onChange={(e) => handleStayInputChange(index, 'checkOut', e.target.value)}
                                        required
                                    />
                                </td>
                                <td>
                                    <input
                                        style={{width: '100px'}}
                                        className="Ajouterfacture__input"
                                        type="number"
                                        placeholder="0,000"
                                        name="prixChambre"
                                        value={formatedNumber(row.prixChambre)}
                                        onChange={(e) => handleStayInputChange(index, 'prixChambre', e.target.value)}
                                        readOnly
                                    />
                                </td>
                                <td className="td-smallest1-width">
                                    <input
                                        className="Ajouterfacture__input"
                                        type="number"
                                        placeholder="0"
                                        name="quantite"
                                        value={row.quantite}
                                        onChange={(e) => handleStayInputChange(index, 'quantite', e.target.value)}
                                        readOnly 
                                    />
                                </td>
                                <td>
                                    <input
                                        style={{width: '110px'}}
                                        className="Ajouterfacture__input"
                                        type="number"
                                        placeholder="0,000"
                                        name="totalLoge"
                                        value={formatedNumber(row.totalLoge)}
                                        readOnly
                                    />
                                </td>

                                {stayRows.length > 1 && (
                                    <td className="Ajouterfacture__button td-smallest-width">
                                        <button
                                            type="button"
                                            onClick={() => deleteStayRow(index)}
                                            className="Ajouterfacture__delete-button"
                                        >
                                            حذف
                                        </button>
                                    </td>
                                )}
                            </tr>
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
            <button type="button" onClick={addStayRow} className="Ajouterfacture__add-button">
                إضافة سطر
            </button>
        </div>

        {/* Fourth Section */}
        <h2 className="Ajouterfacture__section-title">الإضافات</h2>
        {paymentError && <p style={{ color: 'red' }}>{paymentError }</p>}
        <div className="Ajouterfacture__form-section4">
            <table className="Ajouterfacture__form-table">
                <tbody>
                    <tr className="Ajouterfacture__table-header Ajouterfacture__tr-color Ajouterfacture__bold-text">
                        <td colSpan={2} className="Ajouterfacture__dates td-small-width">التاريخ</td>
                        <td>الوصف</td>
                        <td>السعر الفردي</td>
                        <td>الكمية</td>
                        <td>المجموع</td>
                    </tr>
                    {paymentRows.map((row, index) => (
                        <tr className="Ajouterfacture__multivalue" key={index}>
                            <td className="td-large-width ">
                                <input
                                    className="Ajouterfacture__input"
                                    type="date"
                                    placeholder="تاريخ الدخول"
                                    name='enterDate'
                                    value={row.enterDate}
                                    onChange={(e) => handlePaymentInputChange(index, 'enterDate', e.target.value)}
                                    readOnly
                                />
                            </td>
                            <td className="td-large-width ">
                                <input
                                    className="Ajouterfacture__input"
                                    type="date"
                                    placeholder="تاريخ المغادرة"
                                    name='sortDate'
                                    value={row.sortDate}
                                    onChange={(e) => handlePaymentInputChange(index, 'sortDate', e.target.value)}
                                    readOnly
                                />
                            </td>
                            <td>
                                <select 
                                className="Ajouterfacture__select" 
                                name="description" value={row.description} 
                                onChange={(e) => handlePaymentInputChange(index, 'description', e.target.value)}
                                required
                                >
                                    <option value="" disabled>-- اختر --</option>
                                    <option value="مشروبات">مشروبات</option>
                                    <option value="غسيل">غسيل</option>
                                    <option value="عشاء">عشاء</option>
                                    <option value="غداء">غداء</option>
                                    <option value="وجبات مصحوبة بالمشروبات">وجبات  مصحوبة  بالمشروبات</option>
                                </select>
                            </td>
                            <td className="td-middle-width">
                                <input
                                    className="Ajouterfacture__input"
                                    type="number"
                                    placeholder="0,000"
                                    name='unitPrice'
                                    value={row.unitPrice}
                                    onChange={(e) => handlePaymentInputChange(index, 'unitPrice', e.target.value)}
                                    onBlur={handleBlurUnitPrice}
                                    required
                                />
                            </td>
                            <td className="td-smallest-width">
                                <input
                                    className="Ajouterfacture__input"
                                    type="number"
                                    placeholder="0"
                                    name='quantiteConsom'
                                    value={row.quantiteConsom}
                                    onChange={(e) => handlePaymentInputChange(index, 'quantiteConsom', e.target.value)}
                                    readOnly
                                />
                            </td>
                            <td className="td-middle-width">
                                <input
                                    className="Ajouterfacture__input"
                                    type="number"
                                    placeholder="0,000"
                                    name='totalConsom'
                                    value={formatedNumber(row.totalConsom)}
                                    onChange={(e) => handlePaymentInputChange(index, 'totalConsom', e.target.value)}
                                    
                                />
                            </td>
                            {paymentRows.length > 1 && (
                                <td className="Ajouterfacture__button td-smallest-width">
                                    <button
                                        type="button"
                                        onClick={() => deletePaymentRow(index)}
                                        className="Ajouterfacture__delete-button "
                                    >
                                        حذف
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            <button type="button" onClick={addPaymentRow} className="Ajouterfacture__add-button">
                إضافة سطر
            </button>
        </div>

        {/* Fifth Section */}
            <div className="Ajouterfacture__form-section5">
                <table className="Ajouterfacture__form-table">
                    <tbody>
                                            <tr>
                            <td>ظريبة الاقامة</td>
                            <td className="td-small-width Ajouterfacture__text-center">
                                <input
                                    type="radio"
                                    name="tax"
                                    value="Non"
                                    checked={autoTax === "Non"}
                                    onChange={handletaxChange}
                                />
                                Auto
                                <input
                                    type="radio"
                                    name="tax"
                                    value="Oui"
                                    checked={autoTax === "Oui"}
                                    onChange={handletaxChange}
                                />
                                Manuel
                            </td>
                        </tr>
                        <tr>
                           <td>المجموع</td>
                           <td className="Ajouterfacture__payment-td Ajouterfacture__bold-text">
                              <input 
                                  className="Ajouterfacture__input"
                                  type="number" 
                                  name="total" 
                                  placeholder="0,000"
                                  value={formatedNumber(totalFacture)} 
                                  readOnly
                              />
                           </td>
                        </tr>
                        <tr>
                           <td>عمولة {commissionRate} % </td>
                           <td className="Ajouterfacture__payment-td">
                              <input 
                                  className="Ajouterfacture__input"
                                  type="number" 
                                  name="commission" 
                                  placeholder="0,000"
                                  value={formatedNumber(commission)} 
                                  onChange={handleCommissionInputChange}
                                  readOnly
                              />
                           </td>
                        </tr>
                        <tr>
                           <td>القيمة المضافة على العمولة 19 %</td>
                           <td className="Ajouterfacture__payment-td">
                              <input 
                                  className="Ajouterfacture__input"
                                  type="number" 
                                  name="comtax" 
                                  placeholder="0,000"
                                  value={formatedNumber(comtax)} 
                                  onChange={handleComtaxInputChange}
                                  readOnly
                              />
                           </td>
                        </tr>
                        <tr>
                           <td>طابع جبائي</td>
                           <td className="Ajouterfacture__payment-td">
                              <input 
                                  className="Ajouterfacture__input"
                                  type="number" 
                                  placeholder="0,000" 
                                  value={formatedNumber(timbre)} 
                                  readOnly
                              />
                           </td>
                        </tr>
                        <tr>
                           <td>ظريبة الاقامة</td>
                           <td className="Ajouterfacture__payment-td">
                              <input 
                                  className="Ajouterfacture__input"
                                  type="text" 
                                  placeholder="0,000" 
                                  value={autoTax === "Oui" ? tva : tva} 
                                  onChange={handletvaInputChange}
                                  readOnly={autoTax === "Oui"}
                                  {...(autoTax !== "Oui" && { onBlur: handleTvaBlurr })}
                              />
                           </td>
                        </tr>
                        <tr>
                           <td>المبلغ المطلوب</td>
                           <td className="Ajouterfacture__payment-td Ajouterfacture__bold-text"> 
                              <input 
                                  className="Ajouterfacture__input"
                                  type="number" 
                                  name="solde" 
                                  placeholder="0,000" 
                                  value={formatedNumber(solde)} 
                                  readOnly
                              />
                           </td>
                        </tr>
                        <tr>
                           <td>سعر الشراء</td>
                           <td className="Ajouterfacture__payment-td">
                              <input 
                                  className="Ajouterfacture__input"
                                  type="text"
                                  name="montantAchat" 
                                  placeholder="0,000"
                                  value={montantAchat}
                                  onChange={handleMontantAchatInputChange}
                                  onBlur={handleBlur}
                                  required
                              />
                           </td>
                        </tr>
                        <tr>
                           <td>الفارق</td>
                           <td className="Ajouterfacture__payment-td">
                           <input 
                              className="Ajouterfacture__input"
                              type="text" 
                              placeholder="0,000" 
                              value={ecart}
                              readOnly
                            />
                           </td>
                        </tr>
                    </tbody>
                </table>
                <textarea className="Ajouterfacture__textarea" placeholder="ملاحظة ..." value={observation} onChange={handleObservation}></textarea>

                <div className="Ajouterfacture__form-group">
                  <label>إرفاق الملفات (PDF فقط):</label>
                    <input
                      type="file"
                      name="document"
                      accept=".pdf"
                      multiple
                      onChange={handleFileChange}
                    />
                </div>

                {files.length > 0 && (
                <div>
                  <h4>Uploaded Files</h4>
                    <ul className='Ajouterfacture__fileurls'>
                    {files.map((file, index) => (
                        <li key={index}>
                          {file.name}{" "}
                           <button type="button" className="deleteFile" onClick={() => handleRemoveFilee(index)}>
                             Delete
                            </button>
                       </li>
                    ))}
                    </ul>
                </div>
                )}

                <div className="Ajouterfacture__form-group">
                   <button className="Ajouterfacture__submit-button" onClick={handleSubmit}>Sauvegarder</button>
                   <button className="Ajouterfacture__cancel-button" onClick={onClose}>Annuler</button>
                </div>
            </div>
    </form>
    </div>
</div>
);
};

export default EditFactureModal;








